import { SensorType } from '../../types/sensor-type';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';
import { AzureADSensorController } from '../controller/AzureADSensorController';

export class AzureADSensorComponent extends BaseSensorWebComponent {
  public controller!: AzureADSensorController;
  protected composedSensors = [SensorType.AZURE_AD_AUDIT, SensorType.AZURE_AD_EVENT_HUB];
  public isComposed = true;

  constructor() {
    super();
    this.sensorType = SensorType.AZURE_AD_EVENT_HUB;
    this.initialSetup({
      controllerConstructor: AzureADSensorController,
    });
  }

  public setSensorType(sensorType: SensorType) {
    this.sensorType = sensorType;
  }

  public setEnabled(isEnabled: boolean): void {
    this.controller.setEnabledAllFields(isEnabled);
  }
}
